import React from 'react';
import {HandoverComponent} from '../../components/KYC/Handover';

export const HandoverContainer = () => {
  return <HandoverComponent />;
};
